<style lang="scss">
  main {
    padding: 0;
  }

  .carte {
    height: 99%;
    margin-top: 5px;
    max-height: calc(99% - 5px);
    transform: translateX(0px);
    padding: 2px;
  }
</style>

<template>
  <v-app id="inspire">
    <!-- BEGIN MENU LATERAL -->
    <template v-if="isUserAuthenticated && isSessionOK && isListChantierRetrieved">
      <v-navigation-drawer
        :width="sideBarWidth"
        :clipped="true"
        stateless
        v-model="sideBarMenuVisible"
        fixed
        app
      >
        <v-expansion-panel v-model="panel" :disabled="panelsDisabled" expand>
          <!-- BEGIN LISTE CHANTIER -->
          <v-expansion-panel-content>
            <div slot="header">
              <v-btn block flat
                     color="primary lighten-1"
                     @click.stop="listChantierRequest"
              >
                <v-icon left dark>list</v-icon>
                Liste des chantiers
                <v-badge right color="secondary lighten-1">
                  <span slot="badge">{{getNumChantiers}}</span>
                  <v-icon large color="info lighten-2">
                  </v-icon>
                </v-badge>
              </v-btn>
            </div>
            <v-card>
              <v-card-title>

                <v-text-field
                  v-model="chantierSearch"
                  append-icon="search"
                  label="Recherche de chantiers"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <!-- TODO ajouter un filtre Lausanne
              sur chantiersGeojsonData.features
              ou utiliser une fonction qui retouren tableau filtre
              -->
              <v-data-table
                :headers="chantierHeader"
                :search="chantierSearch"
                :items="chantiersGeojsonData.features"
                class="elevation-1"
              >
                <template slot="items" slot-scope="props">
                  <tr @click="gotoItem(props.item.properties)">
                    <td>
                      {{ props.item.properties.id| convertEntitiesInText | limitTextSize }}
                    </td>
                    <td>
                      {{ props.item.properties.leader| convertEntitiesInText | limitTextSize }}
                    </td>
                    <td>
                      {{ props.item.properties.title| convertEntitiesInText | limitTextSize }}
                    </td>
                    <td>
                      {{props.item.properties.planified_date_begin |
                      dateIso2Europe}}
                    </td>
                    <td>
                      {{props.item.properties.real_date_begin |
                      dateIso2Europe}}
                    </td>
                    <td class="justify-center layout px-0">
                      <template v-if="isUserAlreadyRegisteredWithItem(props.item)">
                        <v-tooltip top>
                          <v-icon medium  slot="activator" color="green lighten-1">
                            check
                          </v-icon>
                          <span>Vous êtes inscrit à ce chantier</span>
                        </v-tooltip>
                        </template>
                      <template v-if="canUserEditItem(props.item)">
                        <v-tooltip top>
                          <v-btn slot="activator" @click="editItem(props.item)" icon>
                            <v-icon medium color="blue lighten-1">edit
                            </v-icon>
                          </v-btn>
                          <span>Cliquez pour éditer ce chantier</span>
                        </v-tooltip>
                        <v-tooltip top>
                          <v-btn slot="activator" @click="deleteItem(props.item)" icon>
                            <v-icon medium  color="blue lighten-1">delete
                            </v-icon>
                          </v-btn>
                          <span>Cliquez pour effacer ce chantier</span>
                        </v-tooltip>
                      </template>
                      <template v-else>
                        <v-tooltip top>
                          <v-btn slot="activator" @click="showItem(props.item)" icon>
                            <v-icon medium  color="blue lighten-1">assignment
                            </v-icon>
                          </v-btn>
                          <span>Cliquez pour voir la fiche détaillée de ce chantier</span>
                        </v-tooltip>
                      </template>
                    </td>
                  </tr>
                </template>
                <template slot="no-data">
                  <v-alert :value="true" color="warning" icon="warning">
                    Aucune données coordination chantier
                  </v-alert>
                </template>
              </v-data-table>
            </v-card>
          </v-expansion-panel-content>
          <!-- END LISTE CHANTIER -->
          <v-expansion-panel-content :readonly="true">
            <div slot="header">
              <v-btn
                block flat color="primary lighten-1"
                @click.stop="newItem"
              >
                <v-icon left dark>list</v-icon>
                {{ chantierDialogTitle }}
              </v-btn>
            </div>
            <!-- BEGIN CHANTIER FORM  -->
            <v-card ref="ChantierForm">

              <v-container grid-list-sm class="pa-4">
                <v-layout row wrap>
                  <v-flex xs12 align-center justify-space-between>
                    <v-layout align-center>
                      <v-avatar size="50px" class="mr-3">
                        <img src="./assets/chantier.svg" alt="Chantier">
                      </v-avatar>
                      <v-text-field ref="title" v-model="chantierEdit.title"
                        required
                        :counter="maxTextLength"
                        :rules="[() => !!chantierEdit.title || 'Ce champ est obligatoire',
                                 () =>
                                 (chantierEdit.title.length <= maxTextLength)
                                 || '255 caractères maximum']"
                        :error-messages="errorMessages"
                        v-bind:readonly="dialogFormChantierReadOnlyMode"
                        v-bind:clearable="!dialogFormChantierReadOnlyMode"
                        label="Titre"
                      >
                      </v-text-field>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 align-center justify-space-between>
                    <v-layout align-center>
                      <v-textarea ref="description" rows="3"
                                  v-model="chantierEdit.description"
                        v-bind:readonly="dialogFormChantierReadOnlyMode"
                        v-bind:clearable="!dialogFormChantierReadOnlyMode"
                        label="Description"
                      >
                      </v-textarea>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 align-center justify-space-between>
                    <v-layout align-center>
                      <v-textarea ref="commentaire" rows="4"
                                  v-model="chantierEdit.commentaire"
                        v-bind:readonly="dialogFormChantierReadOnlyMode"
                        v-bind:clearable="!dialogFormChantierReadOnlyMode"
                        prepend-icon="notes"
                        label="Commentaire"
                      >
                      </v-textarea>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field ref="entiteleader"
                      prepend-icon="business"
                      v-model="chantierEdit.entiteleader"
                      label="Entité leader chantier"
                      readonly disabled
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 v-if="chantierEdit.is_external">
                    <v-switch
                      ref="is_projet_definitif_en_cours"
                      v-model="chantierEdit.is_projet_definitif_en_cours"
                      v-bind:disabled="dialogFormChantierReadOnlyMode"
                      :label="`${getSwitchLabelEncours(chantierEdit.is_projet_definitif_en_cours)}`"
                    ></v-switch>
                  </v-flex>
                  <v-flex xs12 sm6 v-if="!chantierEdit.is_external">
                    <v-text-field ref="statut"
                      prepend-icon="info"
                      v-model="chantierEdit.statut"
                      label="Statut du chantier"
                      readonly disabled
                    ></v-text-field>
                  </v-flex>

                  <!-- planified_date_begin -->
                  <v-flex xs12 sm6>
                    <v-menu
                      :close-on-content-click="false"
                      v-model="menuPlanified_date_begin"
                      v-bind:disabled="dialogFormChantierReadOnlyMode"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
                      min-width="290px"
                    >
                      <v-text-field
                        ref="planified_date_begin"
                        slot="activator"
                        v-model="computedPlanified_date_begin"
                        :rules="[() => !!chantierEdit.planified_date_begin
                         || 'Ce champ est obligatoire']"
                        label="Date de début prévue le:"

                        persistent-hint
                        prepend-icon="event"
                        readonly
                      ></v-text-field>
                      <v-date-picker
                        locale="fr"
                        first-day-of-week="1"
                        v-model="chantierEdit.planified_date_begin"
                        v-bind:readonly="dialogFormChantierReadOnlyMode"
                        :max="chantierEdit.planified_date_end"
                        no-title @input="menuPlanified_date_begin = false"
                        required
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                  <!-- planified_date_end -->
                  <v-flex xs12 sm6>
                    <v-menu
                      :close-on-content-click="false"
                      v-model="menuPlanified_date_end"
                      v-bind:disabled="dialogFormChantierReadOnlyMode"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
                      min-width="290px"
                    >
                      <v-text-field
                        ref="planified_date_end"
                        slot="activator"
                        v-model="computedPlanified_date_end"
                        label="Date de fin prévue le:"
                        :rules="[() => !!chantierEdit.planified_date_end
                         || 'Ce champ est obligatoire']"
                        persistent-hint
                        prepend-icon="event"
                        readonly
                      ></v-text-field>
                      <v-date-picker
                        locale="fr"
                        first-day-of-week="1"
                        v-model="chantierEdit.planified_date_end"
                        v-bind:readonly="dialogFormChantierReadOnlyMode"
                        :min="chantierEdit.planified_date_begin"
                        no-title @input="menuPlanified_date_end = false"
                        required
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                  <!-- real_date_begin -->
                  <v-flex xs12 sm6>
                    <v-menu
                      :close-on-content-click="false"
                      v-model="menuReal_date_begin"
                      v-bind:disabled="dialogFormChantierReadOnlyMode"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
                      min-width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        ref="real_date_begin"
                        v-model="computedReal_date_begin"
                        label="Date de début effective le:"
                        hint="JJ-MM-AAAA format"
                        persistent-hint
                        prepend-icon="event"
                        readonly
                      ></v-text-field>
                      <v-date-picker
                        locale="fr"
                        first-day-of-week="1"
                        v-model="chantierEdit.real_date_begin"
                        v-bind:readonly="dialogFormChantierReadOnlyMode"
                        :max="chantierEdit.real_date_end"
                        no-title @input="menuReal_date_begin = false"
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                  <!-- real_date_end -->
                  <v-flex xs12 sm6>
                    <v-menu
                      :close-on-content-click="false"
                      v-model="menuReal_date_end"
                      v-bind:disabled="dialogFormChantierReadOnlyMode"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
                      min-width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        ref="real_date_end"
                        v-model="computedReal_date_end"
                        label="Date de fin effective le:"
                        hint="JJ-MM-AAAA format"
                        persistent-hint
                        prepend-icon="event"
                        readonly
                      ></v-text-field>
                      <v-date-picker
                        locale="fr"
                        first-day-of-week="1"
                        v-model="chantierEdit.real_date_end"
                        v-bind:readonly="dialogFormChantierReadOnlyMode"
                        :min="chantierEdit.real_date_begin"
                        no-title @input="menuReal_date_end = false"
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                  <!--
                  <v-flex xs12 v-if="chantierEdit.is_external" >
                    <v-text-field ref="infos_complementaire_partenaire"
                      prepend-icon="info"
                      v-model="chantierEdit.infos_complementaire_partenaire"
                      v-bind:readonly="dialogFormChantierReadOnlyMode"
                      v-bind:disabled="dialogFormChantierReadOnlyMode"
                      v-bind:clearable="!dialogFormChantierReadOnlyMode"
                      label="Impact trafic du chantier (SDOL)"
                    ></v-text-field>
                  </v-flex>
                  -->
                  <v-flex xs12 v-if="chantierEdit.is_external" >
                    <v-select
                      ref="infos_complementaire_partenaire"
                      :items="infos_complementaire_partenaire_items"
                      v-model="chantierEdit.infos_complementaire_partenaire"
                      v-bind:readonly="dialogFormChantierReadOnlyMode"
                      v-bind:disabled="dialogFormChantierReadOnlyMode"
                      label="Impact trafic du chantier (OL)"

                    ></v-select>
                  </v-flex>
                  <v-flex xs12 v-if="!dialogFormChantierReadOnlyMode">
                    <v-text-field ref="geom_wkt"
                      prepend-icon="create"
                      :rules="[() => !!chantierEdit.geom_wkt
                         || msgErreurGeom]"
                      placeholder="Veuillez saisir/éditer la géométrie dans la carte à droite"
                      v-model="chantierEdit.geom_wkt"
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <!-- DEBUT LISTE PARTICIPANTS Ville de Lausanne -->
                  <v-flex xs12 v-if="chantierEdit.participantsVdlParsed.length>0">
                    <h3>Participants Ville de Lausanne</h3>
                    <!--<v-text-field ref="participantsVDL" v-model="chantierEdit.participants_vdl"
                        v-bind:readonly="dialogFormChantierReadOnlyMode"
                        v-bind:disabled="dialogFormChantierReadOnlyMode"
                        v-bind:clearable="!dialogFormChantierReadOnlyMode"
                        prepend-icon="notes"
                        label="Commentaire"
                      >
                      </v-text-field>-->
                    <ul id="participantsVDL">
                      <li v-for="(item, index) in chantierEdit.participantsVdlParsed" :key="index">
                        {{ item.service }}, {{ item.role }} : {{ item.description }}
                      </li>
                    </ul>
                  </v-flex>
                  <!-- FIN LISTE PARTICIPANTS Ville de Lausanne -->
                  <!-- DEBUT LISTE PARTICIPANTS EXTERNE -->
                  <v-flex xs12 v-if="chantierEdit.participantsExternal.length>0">
                    <h3>Participants </h3>
                    <!--<v-text-field ref="participantsVDL" v-model="chantierEdit.participants_vdl"
                        v-bind:readonly="dialogFormChantierReadOnlyMode"
                        v-bind:disabled="dialogFormChantierReadOnlyMode"
                        v-bind:clearable="!dialogFormChantierReadOnlyMode"
                        prepend-icon="notes"
                        label="Commentaire"
                      >
                      </v-text-field>-->
                    <ul id="participantsExterne">
                      <li v-for="(item, index) in chantierEdit.participantsExternal" :key="index">
                        <template v-if="chantierEdit.identiteleader === item.iduser">
                          LEADER:
                          {{chantierEdit.entiteleader}}, {{ item.contact }} : {{ item.description }}
                        </template>
                        <template v-else>
                          {{ item.entreprise }}, {{ item.contact }} : {{ item.description }}
                        </template>
                      </li>
                    </ul>
                  </v-flex>
                  <!-- FIN LISTE PARTICIPANTS Ville de Lausanne -->
                  <!-- DEBUT GESTION PARTICIPATION USER CONNECTE -->
                  <v-flex xs12 align-center justify-space-between color="secondary">
                    <h3>{{getLabelParticipation(chantierEdit.id)}}</h3>
                    <template
                      v-if="chantierEdit.isNotRegistered &&
                      canUserRegisterChantier(chantierEdit.id)">
                      <v-switch
                      ref="wantToRegisterSwitch"
                      v-model="showRegisterForm"
                      label="Cliquez pour procéder à votre enregistrement"
                    ></v-switch>
                    </template>
                  </v-flex>
                  <template v-if="showRegisterForm">
                    <v-flex xs12 align-center justify-space-between>
                        <v-layout align-center>
                          <v-text-field
                            ref="participationContact"
                            v-model="chantierParticipeEdit.contact"
                            label="Votre contact pour ce chantier"
                            required
                            :counter="maxTextLength"
                            :rules="[() => !!chantierParticipeEdit.contact
                              || 'Ce champ est obligatoire',
                            () => (chantierParticipeEdit.contact.length <= maxTextLength)
                              || '255 caractères maximum']"
                          :error-messages="errorMessages"
                          >
                          </v-text-field>
                        </v-layout>
                    </v-flex>
                    <v-flex xs12 align-center justify-space-between>
                        <v-layout align-center>
                          <v-text-field
                            ref="description"
                            v-model="chantierParticipeEdit.description"
                            clearable
                            label="Description Participation">
                          </v-text-field>
                        </v-layout>
                    </v-flex>
                  </template>
                </v-layout>
              </v-container>
              <v-card-actions>
                <template v-if="chantierEdit.isNotRegistered && showRegisterForm">
                    <v-btn flat
                           @click.native="registerWithChantier(chantierEdit.id)"
                           color="primary"
                           v-bind:disabled="chantierParticipeEdit.contact.length < 3">
                       Enregistrer mes infos d'inscription
                    </v-btn>
                  </template>
                <template v-if="!chantierEdit.isNotRegistered && !chantierEdit.isLeader">
                    <v-btn flat
                           @click.native="registerWithChantier(chantierEdit.id)"
                           color="primary">
                       Enregistrer
                    </v-btn>
                    <v-btn flat v-if="!chantierEdit.isLeader"
                           @click.native="unRegisterWithChantier(chantierEdit.id)"
                           color="warning">
                        Supprimer mon inscription
                    </v-btn>
                </template>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click.native="closeDialog">
                  {{dialogFormChantierReadOnlyMode ? 'Fermer le détail' : 'Annuler'}}
                </v-btn>
                <div v-if="!dialogFormChantierReadOnlyMode">
                  <v-btn  flat @click.native="saveDialog">Sauver</v-btn>
                </div>
              </v-card-actions>
            </v-card>
            <!-- END CHANTIER FORM-->
          </v-expansion-panel-content>
        </v-expansion-panel>

      </v-navigation-drawer>
    </template>
    <!-- END MENU LATERAL -->
    <!-- BEGIN TOP TOOLBAR  -->
    <v-toolbar
      :clipped-left="true"
      color="primary darken-1"
      dark
      app
      fixed
      dense
    >
      <v-toolbar-title style="width: 300px" class="ml-0 pl-2">
        <template v-if="isSessionOK">
          <v-toolbar-side-icon
            @click.stop="sideBarMenuVisible = !sideBarMenuVisible"
          ></v-toolbar-side-icon>
        </template>
        <span class="hidden-sm-and-down">{{AppTitle}}</span>
      </v-toolbar-title>
      <!-- Recherche dans Toolbar
      <template v-if="isSessionOK">
        <v-text-field
          flat
          solo-inverted
          hide-details
          prepend-inner-icon="search"
          label="Recherche"
          class="hidden-sm-and-down"
        ></v-text-field>
      </template>
      -->
      <v-spacer></v-spacer>
      <!--
      <v-btn icon @click="alertMessageShow = true">
        <v-icon>notifications</v-icon>
      </v-btn>
      -->
      <template v-if="isSessionOK">
        <div v-if="isInDev">
        <v-btn
          color="primary"
          @click.prevent="checkIsSessionTokenValid"
          :disabled="!isUserAuthenticated"
        >
          Statut de la connexion
        </v-btn>
        </div>
        <v-tooltip bottom>
          <v-btn slot="activator" icon @click="logout">
            <v-icon>meeting_room</v-icon>
          </v-btn>
          <span>Vous êtes authentifié comme {{userEmail}},
                        cliquez pour vous déconnecter !</span>
        </v-tooltip>
        <v-tooltip bottom>
          <v-btn slot="activator" icon href="/dbdump/legende.pdf" download>
            <v-icon>label</v-icon>
          </v-btn>
          <span>Cliquez pour obtenir la légende</span>
        </v-tooltip>
        <v-tooltip bottom>
          <v-btn slot="activator" icon large download>
            <a href="/dbdump/chantier_all.xlsx" download>
              <v-avatar size="32px" tile>
                <img src="./assets/save2xls.svg" alt="Chantier">
              </v-avatar>
            </a>
          </v-btn>
          <span>Cliquez pour vous récupérer les données au format xls (pour tableurs Excel)!</span>
        </v-tooltip>
        <v-tooltip bottom>
          <v-btn slot="activator" icon large download>
            <a href="/dbdump/chantier_all.sqlite" download>
              <v-avatar size="32px" tile>
                <img src="./assets/logo.svg" alt="Chantier">
              </v-avatar>
            </a>
          </v-btn>
          <span>Cliquez pour vous récupérer le dump de ce matin des chantiers !</span>
        </v-tooltip>
      </template>
      <template v-else>
        <v-tooltip bottom>
          <v-btn slot="activator" icon>
            <v-icon>no_meeting_room</v-icon>
          </v-btn>
          <span>Vous êtes déconnecté ! </span>
        </v-tooltip>
        <v-btn icon large>
        <v-avatar size="32px" tile>
          <img src="./assets/logo.svg" alt="Chantier">
        </v-avatar>
      </v-btn>
      </template>
    </v-toolbar>
    <!-- END  TOP TOOLBAR  -->
    <!-- BEGIN Main Content -->
    <v-content>
      <!--<v-container fluid class="pa-1 mx-0">
        <v-layout justify-center align-center>-->
      <v-snackbar
        v-model="alertMessageShow"
        :color="alertMessageColor"
        top vertical :timeout="alertMessageTimeout"
      >
        <span v-html="alertMessageText"></span>
      <v-btn
        color="pink"
        flat
        @click="alertMessageShow = false"
      >
        Fermer
      </v-btn>
      </v-snackbar>
      <template v-if="!isUserAuthenticated">
      <login
        @loginOK="loginSuccess"
      >
      </login>
      </template>
      <template v-if="isUserAuthenticated">
        <div class="carte">
          <cgil-ol-map
            ref="mymap"
            :center="center"
            :zoom="2"
            :edit-geom-enabled="editToolbarEnabled"
            :search-enabled="true"
            :layers-config="mapLayers"
            :use-internal-wmts="false"
            baselayer="fonds_geo_osm_bdcad_gris"
            :geomWkt="chantierEdit.geom_wkt"
            @gomapSaveGeomClick="saveGeometry"
            @mapclick="handleMapCLick"
          >
          </cgil-ol-map>
        </div>
      </template>

      <!-- </v-layout>
     </v-container>-->
    </v-content>
    <!-- END Main Content -->
    <!--
    <v-btn
      :value="isSessionOK" :disabled="!isSessionOK"
      fab bottom right color="pink"
      dark fixed
      @click.stop="dialogFormChantier = !dialogFormChantier"
    >
      <v-icon>add</v-icon>
    </v-btn>
    -->
  </v-app>
</template>


<script>

// import cgilOlMap from 'cgil-vue-olmap';
// noinspection ES6CheckImport
import { dateIso2Fr, isNullOrUndefined, getStringParam } from 'cgil-html-utils';
import cgilOlMap from './components/cgil-vue-olmap.vue';
import Login from './components/Login.vue';
import {
  DEFAULT_BASE_SERVER_URL, LAUSANNE_OFSID,
  VERSION, BUILD_DATE,
  getLog, DEV,
} from './config';
import { hexToArr } from './components/tools';
import {
  clearSessionStorage,
  doesCurrentSessionExist,
  getTokenStatus,
  getUserEmail,
  getUserExtent,
  getUserId,
  getUserIsAdmin,
  getUserCommuneOfsId,
  getUserIsInSdol,
  getUserName,
  logoutAndResetToken,
} from './components/Login';
import chantier from './components/chantier';
import chantierEdit from './components/chantier_vue_mixin';

const MODULE_NAME = 'ChantierApp';
const log = getLog(MODULE_NAME, 4, 2);

const pos = [538350.5, 152669.0]; // cathedrale Lausanne
const baseLayerSelected = getStringParam('baselayer', 'fonds_geo_osm_bdcad_gris');
const layersVisibility = getStringParam('lvisibles', '41');
const arrLayersVisibility = hexToArr(`0x${layersVisibility}`);
log.w(`layersVisibility:${layersVisibility} => arrLayersVisibility: ${arrLayersVisibility}`);

const convertEnt = (text) => {
  if (isNullOrUndefined(text)) return '';
  let textFiltered = `${text}`.trim();
  textFiltered = textFiltered.replace(/&#39;/g, '\'');
  textFiltered = (`${text}`).replace(
    /&#\d+;/gm,
    s => String.fromCharCode(s.match(/\d+/gm)[0]),
  );
  return textFiltered;
};

const myOnCloseHandlerwindow = (e) => {
  log.w('# IN EVENT beforeunload ');
  // bon ben les nouveaux navigateurs en ont rien a foutre du message...
  // https://stackoverflow.com/questions/24081699/why-onbeforeunload-event-is-not-firing
  const confirmationMessage = 'Voulez vous vraiment quitter cette page ?';
  e.returnValue = confirmationMessage; // Gecko + IE
  return confirmationMessage; // Webkit, Safari, Chrome
};

export default {
  name: 'CoordChantiers',
  mixins: [chantierEdit],
  components: {
    login: Login,
    cgilOlMap,
  },
  data: () => ({
    AppTitle: `Coord Chantiers ${VERSION}`,
    closeHandlerActive: false,
    sideBarWidth: 780,
    center: pos,
    isInDev: DEV,
    isUserAuthenticated: false,
    panel: [true, false], // 0-list, 1-form
    panelsDisabled: false,
    editToolbarEnabled: false,
    alertMessageShow: false,
    alertMessageText: 'Rien à signaler',
    alertMessageTimeout: 7000, // 7 sec par defaut
    alertMessageColor: 'success',
    chantiersGeojsonData: [
      {
        id: 0,
        nom: '',
        description: '',
      },
    ],
    chantiersParticipants: null, // tous les  participants externes (pas de Lausanne)
    userEmail: null,
    userIsAdmin: false,
    // dialog: false,
    sideBarMenuVisible: false,
    advancedMenuItems: [
      {
        icon: 'local_printshop',
        text: 'Imprimer',
        action: 'goprint',
      },
      {
        icon: 'save_alt',
        text: 'Export (shp)',
        action: 'goexport',
      },
      {
        icon: 'settings',
        text: 'Réglages',
        action: 'gosettings',
      },
      {
        icon: 'chat_bubble',
        text: 'Envoyer feedback',
        action: 'gofeedback',
      },
      {
        icon: 'help',
        text: 'Aide',
        action: 'gohelp',
      },
    ],
    infos_complementaire_partenaire_items: [
      '- A DEFINIR -',
      'Nul (hors chaussée)',
      'Faible (ex: rétrécissement de chaussée)',
      'Fort (ex: feux ou fermeture d\'un sens de circulation)',
    ],
    isListChantierRetrieved: false,
    showListChantier: false,
    showRegisterForm: false,
    chantierSearch: '',
    chantierHeader: [
      {
        text: 'Id',
        align: 'left',
        sortable: true,
        value: 'properties.id',
        width: 20,
      },
      {
        text: 'Leader',
        align: 'left',
        sortable: true,
        value: 'properties.leader',
        width: 60,
      },
      {
        text: 'nom du chantier',
        align: 'left',
        value: 'properties.title',
        width: 200,
      },
      {
        text: 'début planifié',
        align: 'left',
        value: 'properties.planified_date_begin',
        width: 40,
      },
      {
        text: 'début effectif',
        align: 'left',
        value: 'properties.real_date_begin',
        width: 40,
      },
      {
        text: 'actions',
        align: 'center',
        sortable: false,
        value: false,
        width: 20,
      },
    ],
    chantierEditedIndex: -1,
    menuPlanified_date_begin: false,
    menuPlanified_date_end: false,
    menuReal_date_begin: false,
    menuReal_date_end: false,
    maxTextLength: 255,
    dialogFormChantier: false,
    dialogFormChantierReadOnlyMode: false,
    dialogFormChantierHasErrors: false,
    msgErreurGeom: 'Veuillez saisir une géométrie dans la carte ci-contre, ce champ est obligatoire !',
    errorMessages: '',
    mapLayers: {
      baseLayer: baseLayerSelected,
      layerForQueryInit: 'bdcad_bf_parc_pol,bdcad_bf_parc_pol_dp,bdcad_bf_parc_pol_ddp,bdcad_cs_bati_pol,bdcad_cs_bati_pol_sout,bdcad_bf_point',
      wmsLayers: [
        {
          layers: 'bdcad_projets_msgroup',
          title: 'Projets et chantiers',
          isVisible: arrLayersVisibility[0],
        },
        {
          layers: 'bdcad_pf_pfp_msgroup,bdcad_pf_pfp_alti',
          title: 'PFP',
          isVisible: arrLayersVisibility[1],
        },
        {
          layers: 'bdcad_pfp_reperage_msgroup',
          title: 'PFP repérage',
          isVisible: arrLayersVisibility[2],
        },
        {
          layers: 'bdcad_pf_pfa_msgroup,bdcad_pf_pfa_alti',
          title: 'PFA',
          isVisible: arrLayersVisibility[3],
        },
        { // je choisis la version du GC public pour que cela fonctionne partout
          layers: 'envconst_arbres_public_remarquables,envconst_arbres_public_remplacement,envconst_arbres_public_projet,envconst_arbres_public_abattage,envconst_arbres_public_autres',
          title: 'Arbres',
          isVisible: arrLayersVisibility[4],
        },
        {
          layers: 'envconst_toitures_veg',
          title: 'Toitures Végétalisées',
          isVisible: arrLayersVisibility[5],
        },
        /* // pas disponible sur map :
        {
          layers: 'bdcad_bf_parcom_pol',
          title: 'Parcelles Communales',
          isVisible: arrLayersVisibility[6],
        },
           */
        {
          layers: 'perimetres_lim_com_msgroup',
          title: 'Limites Communales',
          isVisible: arrLayersVisibility[6],
        },
        {
          layers: 'altimetrie_hauteur_vegetation_mnc_class',
          title: 'Canopée végétation',
          isVisible: arrLayersVisibility[7],
        },
      ],
    }, // FIN DE LA CONFIG DES mapLayers
    /*
              chantiers: [
                { id: 0, nom: '', description: '' },
              ],
              */
  }),
  props: {
    source: String,
    base_server_url: {
      type: String,
      default: DEFAULT_BASE_SERVER_URL,
    },
  },
  computed: {
    isSessionOK() {
      if (this.isUserAuthenticated) {
        const sessionOk = doesCurrentSessionExist();
        log.t(`# IN computed isSessionOK(${sessionOk})`);
        return sessionOk;
      }
      return false;
    },
    getNumChantiers() {
      if (isNullOrUndefined(this.chantiersGeojsonData.features)) return 0;
      return this.chantiersGeojsonData.features.length;
    },
    chantierDialogTitle() {
      let strMSg = ' ';
      if (this.chantierEditedIndex === -1) {
        strMSg += 'Nouveau chantier';
      } else {
        strMSg = this.dialogFormChantierReadOnlyMode ? 'Détail' : 'Edition';
        strMSg += ` du chantier id[${this.chantierEdit.id}], `;
        strMSg += ` créé le ${this.convertTimestamp2Europe(this.chantierEdit.datecreated)}`;
        if (+this.chantierEdit.id_affaire_goeland > 0) {
          strMSg += ` Aff Goéland: ${this.chantierEdit.id_affaire_goeland}`;
        }
      }
      return strMSg;
    },
    computedPlanified_date_begin() {
      return this.convertDateIso2Europe(this.chantierEdit.planified_date_begin);
    },
    computedPlanified_date_end() {
      return this.convertDateIso2Europe(this.chantierEdit.planified_date_end);
    },
    computedReal_date_begin() {
      return this.convertDateIso2Europe(this.chantierEdit.real_date_begin);
    },
    computedReal_date_end() {
      return this.convertDateIso2Europe(this.chantierEdit.real_date_end);
    },
  },
  filters: {
    dateIso2Europe(isoDate) {
      if (isNullOrUndefined(isoDate)) return '';
      return dateIso2Fr(isoDate);
    },
    limitTextSize(text, maxSize = 100) {
      if (isNullOrUndefined(text)) return '';
      if (text.length < maxSize) return text;
      return `${text.substring(0, maxSize)}…`;
    },
    convertEntitiesInText(text) {
      return convertEnt(text);
    },
  },
  mounted() {
    log.t('# IN mounted()');
    log.w(`COORDINATION CHANTIER Version ${VERSION}, du ${BUILD_DATE}`);
    if (DEV) {
      log.t('## No need to login 100 times when doing dev');
      this.checkIsSessionTokenValid();
    } else {
      clearSessionStorage();
    }
    this.userEmail = getUserEmail();
  }, // end of mounted
  beforeUnmount() {
    log.t('# IN beforeUnmount()');
    this.logout();
  }, // end of unmounted
  methods: {
    getSwitchLabelEncours(val) {
      if (val) {
        return 'OUI le projet définitif est en cours';
      }
      return 'NON le projet définitif n\'est pas en cours';
    },
    getSwitchLabelParticipation(val) {
      if (val) {
        return 'OUI, Vous voulez participer à ce chantier';
      }
      return 'NON Vous ne voulez plus participer à ce chantier';
    },
    getLabelParticipation(idChantier) {
      const localDebug = false;
      const res = this.isUserRegisteredToChantier(idChantier);
      if (localDebug) log.w(`# IN getLabelParticipation(${idChantier}) isRegistered : ${res}`);
      if (idChantier === 0) {
        // on est sur un nouveau chantier
        return 'Vous serez le leader de ce chantier !';
      }
      if (res) {
        if (this.chantierEdit.isLeader) {
          return 'Vous êtes le leader de ce chantier';
        }
        return 'Vous êtes inscrit comme participant à ce chantier';
      }
      if (this.canUserRegisterChantier(idChantier)) {
        return 'Voulez vous participez à ce chantier ?';
      }
      return 'Vous ne pouvez pas participer à ce chantier';
    },
    showMessage(msgText, msgType = 'info') {
      this.alertMessageColor = msgType;
      this.alertMessageText = msgText;
      this.alertMessageShow = true;
    },
    togleForm() {
      this.sideBarMenuVisible = true;
      this.panel = [false, true];
    },
    togleList() {
      this.panel = [true, false];
    },
    convertDateIso2Europe(isoDate) {
      if (isNullOrUndefined(isoDate)) return '';
      return dateIso2Fr(isoDate);
    },
    convertTimestamp2Europe(timeStamp) {
      log.t(`## in convertTimestamp2Europe timeStamp : ${timeStamp}`);
      const addZero2digit = n => (n > 9 ? `${n}` : `0${n}`);
      const tempDate = new Date(timeStamp);
      return `${tempDate.getUTCDate()}-${addZero2digit(tempDate.getUTCMonth() + 1)}-${tempDate.getUTCFullYear()}`;
    },
    runFunction(name, params = null) {
      const fn = this[name];
      if (typeof fn !== 'function') return;
      fn.apply(this, params);
    },
    toggle(index) {
      log.t(`# IN toggle(${index})`);
      const action = index.split('|')[1];
      if (action) this.runFunction(action);
    },
    logout() {
      log.w('# IN logout()');
      this.closeDialog();
      window.removeEventListener('beforeunload', myOnCloseHandlerwindow, false);
      this.closeHandlerActive = false;
      logoutAndResetToken(DEFAULT_BASE_SERVER_URL);
      this.chantierEdit = Object.assign({}, this.chantierDefault);
      this.chantierParticipeEdit = Object.assign({}, this.chantierParticipeDefault);
      this.chantierEditedIndex = -1;
      this.editToolbarEnabled = false;
      this.sideBarMenuVisible = false;
      this.panel = [true, false]; // 0-list, 1-form
      this.panelsDisabled = false;
      this.isUserAuthenticated = false;
      this.userEmail = null;
      this.userIsAdmin = false;
      this.isListChantierRetrieved = false;
      this.chantiersGeojsonData = null;
      this.$refs.mymap.clearGeoJsonData();
      this.$refs.mymap.updateScreen();
      this.chantiersParticipants = null;
      this.alertMessageShow = false;
      this.chantierSearch = '';
      this.menuPlanified_date_begin = false;
      this.menuPlanified_date_end = false;
      this.menuReal_date_begin = false;
      this.menuReal_date_end = false;
      this.dialogFormChantier = false;
      this.dialogFormChantierReadOnlyMode = false;
      this.dialogFormChantierHasErrors = false;
    },
    loginSuccess() {
      log.t('# IN loginSuccess()');
      this.isUserAuthenticated = true;
      this.userEmail = getUserEmail();
      this.getChantierList();
      this.getChantierListParticipants();
      const that = this;
      window.setTimeout(() => {
        that.$refs.mymap.gotoExtent(getUserExtent());
        that.$refs.mymap.updateScreen();
      }, 1200);
    },
    checkIsSessionTokenValid() {
      log.t('# IN checkIsSessionTokenValid()');
      if (doesCurrentSessionExist()) {
        getTokenStatus(this.base_server_url)
          .then((res) => {
            log.t(
              '# IN checkIsSessionTokenValid() getTokenStatus.then success : ',
              res,
            );
            this.isUserAuthenticated = res.is_token_valid;
            if (this.isUserAuthenticated) {
              this.getChantierList();
              this.getChantierListParticipants();
              this.userEmail = getUserEmail();
            }
          })
          .catch((err) => {
            log.e(
              '# IN checkIsSessionTokenValid() getTokenStatus.catch catch ERROR : ',
              err,
            );
            this.isUserAuthenticated = false;
            this.showMessage('### VOTRE SESSION A EXPIRE !<br>VEUILLEZ SVP VOUS RECONNECTER.', 'error');
          });
      } else {
        log.w('SESSION DOES NOT EXIST OR HAS EXPIRED !');
        this.isUserAuthenticated = false;
      }
    },
    getChantierList() {
      log.w('# IN getChantierList() before call chantier.getList()');
      // get list chantiers after successful user login
      chantier.getList((data, errMessage) => {
        if (!isNullOrUndefined(data)) {
          this.chantiersGeojsonData = data;
          log.l(
            '# IN getChantierList -> Chantier data :',
            this.chantiersGeojsonData,
          );
          // populate table
          // this.chantiers = this.chantiersGeojsonData.features.map(o => o.properties);
          this.$refs.mymap.loadGeojsonData(this.chantiersGeojsonData);
          this.$refs.mymap.updateScreen();
          this.isListChantierRetrieved = true;
        } else {
          log.e(`# GOT ERROR IN getChantierList() in callback for chantier.getList data: ${errMessage}`);
          this.isListChantierRetrieved = false;
        }
      });
    },
    getChantierListParticipants() {
      log.w('# IN getChantierListParticipants() before call chantier.getParticipeChantier()');
      // get list chantiers after successful user login
      chantier.getParticipeChantier((data, errMessage) => {
        if (!isNullOrUndefined(data)) {
          this.chantiersParticipants = data.map((o) => {
            const objRes = {};
            objRes.id = o.id_chantier;
            objRes.is_external = o.is_external;
            objRes.users = o.users.split(',').map(v => +v);
            objRes.participants = o.participants;
            return objRes;
          });
          log.l('# IN getChantierList -> Chantier data :', this.chantiersParticipants);
        } else {
          log.e(`# GOT ERROR IN getChantierListParticipants() in callback for
          chantier.getParticipeChantier error: ${errMessage}`);
        }
      });
    },
    getParticipantsToChantier(chantierId) {
      const currentChantier = this.chantiersParticipants.find(e => (e.id === chantierId));
      if (isNullOrUndefined(currentChantier)) {
        log.l(`## getParticipantsToChantier(${chantierId} => PAS DE PARTICIPANTS )`);
        return [];
      }
      const registeredParticipants = currentChantier.participants;
      if (isNullOrUndefined(registeredParticipants)) {
        return [];
      }
      return registeredParticipants;
    },
    gotoItem(item) {
      log.t('# IN gotoItem() item:', item);
      if (!isNullOrUndefined(item)) {
        if (!isNullOrUndefined(item.x)) {
          this.$refs.mymap.gotoNewPos([item.x, item.y]);
        }
      }
    },

    isUserAlreadyRegisteredWithItem(theCurrentChantier) {
      const localDebug = false;
      if (localDebug) log.t('# IN isUserAlreadyRegisterdWithItem() item:', theCurrentChantier);
      if (isNullOrUndefined(theCurrentChantier) ||
          isNullOrUndefined(theCurrentChantier.properties.id) ||
          isNullOrUndefined(theCurrentChantier.properties.id === 0)) {
        if (localDebug) log.w('# IN isUserAlreadyRegisterdWithItem() MISSING INFO');
        return false;
      }
      if (!isNullOrUndefined(this.chantiersParticipants)) {
        if (localDebug) log.w('this.chantiersParticipants', this.chantiersParticipants);
        const currentID = theCurrentChantier.properties.id;
        const response = this.isUserRegisteredToChantier(currentID);
        if (localDebug) log.w(`# IN isUserAlreadyRegisterdWithItem() isRegistered : ${response}`);
        return response;
      }
      if (localDebug) log.w(`# IN isUserAlreadyRegisterdWithItem() USER NOT REGISTER : ${theCurrentChantier.title}`);
      return false;
    },

    canUserEditItem(item) {
      const localDebug = false;
      if (localDebug) log.t('# IN canUserEditItem() item:', item);
      if (isNullOrUndefined(item) ||
          isNullOrUndefined(item.properties) ||
          isNullOrUndefined(item.properties.is_external) ||
          // si is_external est faux alors c'est que chantier vient de lausanne
          item.properties.is_external === false) {
        if (localDebug) log.w(`# IN canUserEditItem() NOT OK TO EDIT : ${item.properties.title}`);
        return false;
      }
      // on peut mettre cela ligne après si on veut eviter edition aff lausanne
      if (getUserIsAdmin()) {
        if (localDebug) log.w(`# IN canUserEditItem() USER IS ADMIN OK TO EDIT : ${item.properties.title}`);
        return true;
      }

      if (item.properties.identiteleader !== getUserId()) {
        if (localDebug) log.w(`# IN canUserEditItem() USER IS NOT OWNER NOT OK TO EDIT : ${item.properties.identiteleader} `, getUserId());
        return false;
      }
      if (localDebug) log.w(`# IN canUserEditItem() USER IS OWNER OK TO EDIT : ${item.properties.title}`);
      return true;
    },
    canUserRegisterChantier(idChantier) {
      if (doesCurrentSessionExist()) {
        if (this.chantierEdit.id > 0) {
          // const currentUser = getUserId;
          if (getUserIsAdmin()) {
            log.l(`canUserRegisterChantier() AN ADMIN CANNOT REGISTER ${idChantier}`);
            return false;
          }
          const chantierItem = this.getChantierItembyId(idChantier);
          log.w(`# IN canUserRegisterChantier(${idChantier}) chantier:`, chantierItem);
          if (!isNullOrUndefined(chantierItem) && !isNullOrUndefined(chantierItem.properties)) {
            if (!isNullOrUndefined(chantierItem.properties.is_saisie_participation_autorisee)) {
              const endOfParticipation = chantierItem.properties.is_saisie_participation_autorisee;
              if (endOfParticipation === false) {
                log.w(`# IN canUserRegisterChantier(${idChantier})
                is_saisie_participation_autorisee: ${endOfParticipation} PARTICPATION INTERDITE`);
                return false;
              }
            }
            if (!isNullOrUndefined(chantierItem.properties.real_date_end)) {
              const dateFin = new Date(chantierItem.properties.real_date_end);
              const dateNow = new Date().setHours(0, 0, 0, 0);
              log.w('## canUserRegisterChantier date de fin :', dateFin);
              if (!isNullOrUndefined(dateFin) && (dateFin < dateNow)) {
                log.w('## canUserRegisterChantier date de fin dans le passé ON PEUT PAS VOYAGER DANS LE TEMPS :-( ');
                return false;
              }
            }
            const chantierCommuneOfsidContains = chantierItem.properties.commune_ofsid_contains;
            const chantierCommuneOfsidIntersects = chantierItem.properties.commune_ofsid_intersects;
            if (isNullOrUndefined(chantierCommuneOfsidContains) &&
              isNullOrUndefined(chantierCommuneOfsidIntersects)) {
              log.w('## ERROR in canUserRegisterChantier chantierCommuneOfsidContains & Intersects ARE NULL PAS BON CA ');
              return false;
            }
            if (getUserIsInSdol()) {
              if (chantierCommuneOfsidContains === LAUSANNE_OFSID) {
                log.l(`canUserRegisterChantier() USER IN SDOL CANNOT REGISTER ${idChantier} CONTAINED IN LAUSANNE`);
                return false;
              }
              if (chantierCommuneOfsidIntersects.split(',').map(v => +v).includes(getUserCommuneOfsId())) {
                log.l(`canUserRegisterChantier() USER IN SDOL CAN REGISTER ${idChantier} INTERSECTING IS COMMUNE`);
                return true;
              }
              if (chantierCommuneOfsidIntersects.split(',').map(v => +v).includes(LAUSANNE_OFSID)) {
                log.l(`canUserRegisterChantier() USER IN SDOL CANNOT REGISTER LAUSANNE ${idChantier} NOT INTERSECTING IS COMMUNE`);
                return false;
              }
              log.l(`canUserRegisterChantier() USER IN SDOL CAN REGISTER ${idChantier} OUTSIDE LAUSANNE`);
              return true;
            }
            // ici on traite le cas d'un utilisateur qui est pas dans le SDOL
            log.l(`canUserRegisterChantier() USER NOT IN SDOL CAN REGISTER ${idChantier} `);
            return true;
          }
        } else {
          // on est en train de creer un nouveau chantier
          if (getUserId() === this.chantierEdit.identiteleader) {
            log.l(`canUserRegisterChantier() USER CREATING NEW CHANTIER  CAN REGISTER ${idChantier}`);
            return true;
          }
          return false;
        }
      }
      return false;
    },
    closeDialog() {
      log.t('# IN closeDialog()');
      if (this.closeHandlerActive) {
        window.removeEventListener('beforeunload', myOnCloseHandlerwindow, false);
        this.closeHandlerActive = false;
      }
      this.dialogFormChantier = false;
      this.dialogFormChantierReadOnlyMode = false;
      this.editToolbarEnabled = false;
      this.showRegisterForm = false;
      this.$refs.mymap.clearNewFeatures();
      this.togleList();
      this.panelsDisabled = false;
      setTimeout(() => {
        // on prepare pour un eventuel new Item
        this.chantierEdit = Object.assign({}, this.chantierDefault);
        this.chantierParticipeEdit = Object.assign({}, this.chantierParticipeDefault);
        this.chantierEditedIndex = -1;
      }, 300);
    },
    newItem() {
      log.t('# IN newItem()');
      if (!this.closeHandlerActive) {
        window.addEventListener('beforeunload', myOnCloseHandlerwindow, false);
        this.closeHandlerActive = true;
      }
      this.$refs.mymap.gotoExtent(getUserExtent());
      this.chantierEdit.isLeader = true;
      this.chantierEdit.is_external = true;
      this.chantierEdit.identiteleader = getUserId();
      this.chantierEdit.entiteleader = getUserName();
      this.chantierEdit.datecreated = new Date();
      this.editToolbarEnabled = true;
      this.showRegisterForm = true;
      this.chantierParticipeEdit = Object.assign({}, this.chantierParticipeDefault);
      this.chantierParticipeEdit.id = 0;
      this.chantierParticipeEdit.id_affaire = 0;
      // toujours true quand on créée un nouveau chantier sur plateforme
      this.chantierParticipeEdit.is_external = true;
      this.chantierParticipeEdit.contact = '';
      this.chantierParticipeEdit.description = '';
      this.chantierParticipeEdit.datecreated = new Date();
      // log.w(`CURRENT PARTICIPANT ${JSON.stringify(this.chantierParticipeEdit, null, 2)}`);
      this.togleForm();
      this.panelsDisabled = true;
    },
    isUserRegisteredToChantier(idChantier) {
      const localDebug = false;
      if (isNullOrUndefined(this.chantiersParticipants)) return false;
      const currentChantier = this.chantiersParticipants.find(e => (e.id === idChantier));
      const currentUserId = getUserId();
      const registeredUsers = (!isNullOrUndefined(currentChantier)) ? currentChantier.users : null;
      if (localDebug) log.w(`idChantier: ${idChantier} currentUserId: ${currentUserId} registeredUsers `, registeredUsers);
      if (isNullOrUndefined(registeredUsers) ||
        (registeredUsers.indexOf(currentUserId) < 0)) {
        return false;
      }
      return true;
    },
    editItem(item) {
      log.t('# IN editItem() item:', item);
      if (!this.closeHandlerActive) {
        window.addEventListener('beforeunload', myOnCloseHandlerwindow, false);
        this.closeHandlerActive = true;
      }
      this.editToolbarEnabled = true;
      this.chantierEditedIndex = this.chantiersGeojsonData.features.indexOf(item);
      log.t(
        `# IN editItem() id=${item.properties.id} chantierEditedIndex:`,
        this.chantierEditedIndex,
      );
      this.chantierEdit = Object.assign({}, item.properties);
      this.chantierEdit.title = convertEnt(this.chantierEdit.title);
      this.chantierEdit.description = convertEnt(this.chantierEdit.description);
      this.chantierEdit.commentaire = convertEnt(this.chantierEdit.commentaire);
      const currentID = this.chantierEdit.id;
      // DEBUT SECTION necessaire pour recuperer participants pour une affaire suivi par lausanne
      if (!isNullOrUndefined(this.chantierEdit.participants_vdl)) {
        const participantsVdl = JSON.parse(this.chantierEdit.participants_vdl);
        log.w('--participants_vdl : ', this.chantierEdit.participants_vdl);
        if (isNullOrUndefined(this.chantierEdit.participants_vdl)) {
          this.chantierEdit.participantsVdlParsed = [];
        } else {
          this.chantierEdit.participantsVdlParsed = participantsVdl;
        }
        log.w('--participants_vdl PARSED: ', participantsVdl);
      } else {
        this.chantierEdit.participantsVdlParsed = [];
      }
      // FIN SECTION necessaire pour recuperer participants pour une affaire suivi par lausanne
      log.w('this.chantiersParticipants', this.chantiersParticipants);
      this.chantierEdit.participantsExternal = this.getParticipantsToChantier(currentID);
      log.w('--participantsExternal PARSED: ', this.chantierEdit.participantsExternal);
      const currentUserId = getUserId();
      const currentChantier = this.chantiersParticipants.find(e => (e.id === currentID));
      const registeredUsers = (!isNullOrUndefined(currentChantier)) ? currentChantier.users : null;
      log.w(`currentID: ${currentID} currentUserId: ${currentUserId} registeredUsers `, registeredUsers);
      // celui qui peut editer est le CREATEUR est aussi le LEADER donc participe toujours
      // eslint-disable-next-line max-len
      // certes DUCON mais desfois il n'est pas encore inscrit en tant que leader surtout apres import SISOL
      this.chantierEdit.isNotRegistered =
          isNullOrUndefined(registeredUsers) ? true : (registeredUsers.indexOf(currentUserId) < 0);
      this.chantierEdit.isLeader = true;
      log.w(`currentID: ${currentID} currentUserId: ${currentUserId} isNotRegistered :${this.chantierEdit.isNotRegistered}
      registeredUsers :`, registeredUsers);
      this.showRegisterForm = true;
      if (!isNullOrUndefined(registeredUsers)) {
        if ((registeredUsers.indexOf(currentUserId) > -1)) {
          // user enregistre
          const currentParticipant =
            currentChantier.participants.find(e => (e.iduser === currentUserId));
          this.chantierParticipeEdit = Object.assign({}, this.chantierParticipeDefault);
          this.chantierParticipeEdit.id = currentParticipant.id;
          this.chantierParticipeEdit.id_affaire = currentID;
          // toujours true quand on edite sur plateforme
          this.chantierParticipeEdit.is_external = true;
          this.chantierParticipeEdit.contact = convertEnt(currentParticipant.contact);
          this.chantierParticipeEdit.description = convertEnt(currentParticipant.description);
          this.chantierParticipeEdit.datecreated = currentParticipant.datecreated;
        }
      } else {
        this.chantierParticipeEdit = Object.assign({}, this.chantierParticipeDefault);
        this.chantierParticipeEdit.id = 0;
        this.chantierParticipeEdit.id_affaire = currentID;
        // toujours true quand on edite sur plateforme
        this.chantierParticipeEdit.is_external = true;
        this.chantierParticipeEdit.contact = '';
        this.chantierParticipeEdit.description = '';
      }
      log.w(`CURRENT PARTICIPANT ${JSON.stringify(this.chantierParticipeEdit, null, 2)}`);
      this.togleForm();
      this.dialogFormChantierReadOnlyMode = false;
      this.panelsDisabled = true;
      // this.dialogFormChantier = true;
      // bus.$emit('chantierDialogShow', true); // emit the event to the bus
    },

    showItem(item) {
      log.t('# IN showItem() item:', item);
      if (!doesCurrentSessionExist()) this.logout();
      this.chantierEditedIndex = this.chantiersGeojsonData.features.indexOf(item);
      log.t(
        `# IN showItem() id=${item.properties.id} chantierEditedIndex:`,
        this.chantierEditedIndex,
      );
      this.chantierEdit = Object.assign({}, item.properties);
      this.chantierEdit.title = convertEnt(this.chantierEdit.title);
      this.chantierEdit.description = convertEnt(this.chantierEdit.description);
      this.chantierEdit.commentaire = convertEnt(this.chantierEdit.commentaire);
      const participantsVdl = JSON.parse(this.chantierEdit.participants_vdl);
      log.w('--participants_vdl : ', this.chantierEdit.participants_vdl);
      if (isNullOrUndefined(this.chantierEdit.participants_vdl)) {
        this.chantierEdit.participantsVdlParsed = [];
      } else {
        this.chantierEdit.participantsVdlParsed = participantsVdl;
      }
      log.w('--participants_vdl PARSED: ', participantsVdl);
      // is current user allowed to register?
      log.w('this.chantiersParticipants', this.chantiersParticipants);
      const currentID = this.chantierEdit.id;
      this.chantierEdit.participantsExternal = this.getParticipantsToChantier(currentID);
      log.w('--participantsExternal PARSED: ', this.chantierEdit.participantsExternal);
      const currentUserId = getUserId();
      const currentChantier = this.chantiersParticipants.find(e => (e.id === currentID));
      const registeredUsers = (!isNullOrUndefined(currentChantier)) ? currentChantier.users : null;
      log.w(`currentID: ${currentID} currentUserId: ${currentUserId} registeredUsers `, registeredUsers);
      if (isNullOrUndefined(registeredUsers) ||
        (registeredUsers.indexOf(currentUserId) < 0)) {
        this.chantierEdit.isNotRegistered = true;
        this.showRegisterForm = false;
      } else {
        this.chantierEdit.isNotRegistered = false;
        this.showRegisterForm = true;
        // user enregistre
        const currentParticipant =
          currentChantier.participants.find(e => (e.iduser === currentUserId));
        this.chantierParticipeEdit = Object.assign({}, this.chantierParticipeDefault);
        this.chantierParticipeEdit.id = currentParticipant.id;
        this.chantierParticipeEdit.id_affaire = currentID;
        this.chantierParticipeEdit.is_external = currentChantier.is_external;
        this.chantierParticipeEdit.contact = convertEnt(currentParticipant.contact);
        this.chantierParticipeEdit.description = convertEnt(currentParticipant.description);
        this.chantierParticipeEdit.datecreated = currentParticipant.datecreated;
        log.w(`CURRENT PARTICIPANT ${JSON.stringify(this.chantierParticipeEdit, null, 2)}`);

        /*

      identiteleader: null, // READONLY FK iduser

      datecreated: '', // READONLY timestamp db default now()
      idcreator: 0, // READONLY
      datelastmodif: '', // READONLY
    */
      }
      log.w(`currentID: ${currentID} currentUserId: ${currentUserId} isNotRegistered :${this.chantierEdit.isNotRegistered}
      registeredUsers :`, registeredUsers);
      this.togleForm();
      // this.dialogFormChantier = true;
      this.dialogFormChantierReadOnlyMode = true;
      this.panelsDisabled = true;
    },

    deleteItem(item) {
      log.t('# IN deleteItem() item:', item);
      const index = this.chantiersGeojsonData.features.indexOf(item);
      const currentID = item.properties.id;
      // TODO replace confirm with v-alert and add call to server for delete set is_delete
      // eslint-disable-next-line
      if (confirm('êtes-vous sûr de vouloir supprimer ce chantier?')) {
        this.chantiersGeojsonData.features.splice(index, 1);
        log.w(`# IN deleteItem() id: ${currentID} index: ${index}`, item);
        chantier.deleteChantier(currentID, (retval, errorMsg) => {
          if (errorMsg === 'SUCCESS') {
            log.w(`# in callback for chantier.deleteItem id:${currentID} call val`, retval);
            // retval is the number of row affected
            this.showMessage(`Les données de ce chantier id:${currentID} ont été effacée dans la BD ! `, 'success');
            // mise a jour de la carte
            this.$refs.mymap.loadGeojsonData(this.chantiersGeojsonData);
            this.$refs.mymap.updateScreen();
            this.closeDialog();
          } else {
            log.e(`# ERROR in callback for chantier.deleteItem id:${this.chantierEdit.id} call
            ERROR : ${errorMsg}
            val`, retval);
            this.showMessage(`ERREUR pendant l'effacement du chantier id:${currentID} dans la BD !
              ${errorMsg}`, 'error');
          }
        });
      }
    },

    registerWithChantier(idChantier, isExternal = null, silentCall = false) {
      log.t(`# IN registerWithChantier(${idChantier})`);
      const currentID = idChantier;
      let chantierIsExternal = true;
      if (!isNullOrUndefined(isExternal)) {
        chantierIsExternal = isExternal;
      } else {
        const chantierItem = this.getChantierItembyId(currentID);
        log.w(`# IN registerWithChantier(${idChantier}) chantier:`, chantierItem);
        chantierIsExternal = chantierItem.properties.is_external;
      }
      const tempChantierParticipe = {
        idchantier: currentID,
        iduser: getUserId(),
        is_external: chantierIsExternal,
        contact: this.chantierParticipeEdit.contact,
        description: this.chantierParticipeEdit.description,
      };
      log.w(`# IN registerWithItem() id: ${currentID} `, tempChantierParticipe);
      chantier.registerToChantier(currentID, tempChantierParticipe, (retval, errorMsg) => {
        if (errorMsg === 'SUCCESS') {
          log.w(`# in callback for chantier.registerChantier id:${currentID} call val`, retval);
          if (!silentCall) {
            this.showMessage(`Vous vous êtes inscris à ce chantier id:${currentID} dans la BD ! `, 'success');
          }
          // rafraichir information en local
          this.getChantierListParticipants();
        } else {
          log.e(`# ERROR in callback for chantier.registerChantier id:${currentID} call
            ERROR : ${errorMsg}
            val`, retval);
          this.showMessage(`ERREUR pendant l'inscription au chantier id:${currentID} dans la BD !
              ${errorMsg}`, 'error');
        }
      });
    },

    unRegisterWithChantier(idChantier, silentCall = false) {
      log.t(`# IN unRegisterWithChantier(${idChantier})`);
      const currentID = idChantier;
      const chantierItem = this.getChantierItembyId(currentID);
      // log.w(`# IN unRegisterWithChantier(${idChantier}) chantier:`, chantierItem);
      const chantierIsExternal = chantierItem.properties.is_external;
      // eslint-disable-next-line
      if (confirm('êtes-vous sûr de vouloir vous désinscrire de ce chantier?')) {
        log.w(`# IN unRegisterWithChantier(${currentID})`);
        const tempChantierParticipe = {
          idchantier: currentID,
          iduser: getUserId(),
          is_external: chantierIsExternal,
          contact: this.chantierParticipeEdit.contact,
          description: this.chantierParticipeEdit.description,
        };
        chantier.unregisterToChantier(currentID, tempChantierParticipe, (retval, errorMsg) => {
          if (errorMsg === 'SUCCESS') {
            log.w(`# in callback for chantier.unregisterToChantier id:${currentID} call val`, retval);
            // retval is the number of row affected
            if (!silentCall) {
              this.showMessage(`Votre inscription au chantier id:${currentID} a été effacée de la BD ! `, 'success');
            }
            // rafraichir information en local
            this.getChantierListParticipants();
            this.closeDialog();
          } else {
            log.e(`# ERROR in callback for chantier.unregisterToChantier id:${this.chantierEdit.id} call
            ERROR : ${errorMsg}
            val`, retval);
            this.showMessage(`ERREUR pendant l'effacement de votre inscription au chantier id:${currentID} dans la BD !
              ${errorMsg}`, 'error');
          }
        });
      }
    },

    saveGeometry(data) {
      log.t(`# IN saveGeometry() wktGeom:\n ${data.wkt}`, data.geomBB);
      this.$refs.mymap.clearNewFeatures();
      this.chantierEdit.geom_wkt = data.wkt;
      const tempGeoJsonObject = JSON.parse(data.geoJSON);
      this.chantierEdit.geom_GeoJSON = tempGeoJsonObject.geometry;
      // 535971.68, 154270.02, 536561.28, 155167.24
      // TODO: calculer x,y pour position
      this.chantierEdit.x = (data.geomBB[0] + data.geomBB[2]) / 2;
      this.chantierEdit.y = (data.geomBB[1] + data.geomBB[3]) / 2;
    },

    saveDialog() {
      // doing local save for now
      log.t('# in saveDialog');
      this.dialogFormChantierHasErrors = false;
      Object.keys(this.formChantier)
        .forEach((f) => {
          log.w(
            `in saveDialog iterating fields ${f} - this.formChantier[f] ${this.formChantier[f]}`,
            this.$refs[f].validate(true),
          );
          if (!this.$refs[f].validate(true)) this.dialogFormChantierHasErrors = true;
          this.$refs[f].validate(true);
        });
      if (!this.dialogFormChantierHasErrors) {
        if (!doesCurrentSessionExist()) this.logout();
        if (this.chantierEditedIndex > -1) {
          // SAVING MODIFICATIONS TO EXISTING OBJECT
          log.l(`# in saveDialog, will save edited data for index : ${this.chantierEditedIndex}`);
          this.chantierEdit.iduserlastmodif = getUserId();
          this.chantierEdit.datelastmodif = new Date();
          // toujours vrai pour une edition ou creation
          this.chantierEdit.is_external = true;
          Object.assign(
            this.chantiersGeojsonData.features[this.chantierEditedIndex].properties,
            this.chantierEdit,
          );
          Object.assign(
            this.chantiersGeojsonData.features[this.chantierEditedIndex].geometry,
            this.chantierEdit.geom_GeoJSON,
          );
          const currentID = this.chantierEdit.id;
          const tempChantier = {
            idgochantier: currentID,
            name: this.chantierEdit.title,
            description: this.chantierEdit.description,
            commentaire: this.chantierEdit.commentaire,
            planified_datestart: this.chantierEdit.planified_date_begin,
            planified_dateend: this.chantierEdit.planified_date_end,
            real_datestart: this.chantierEdit.real_date_begin,
            real_dateend: this.chantierEdit.real_date_end,
            is_projet_definitif_en_cours: this.chantierEdit.is_projet_definitif_en_cours,
            infos_complementaire_partenaire: this.chantierEdit.infos_complementaire_partenaire,
            geom_polygon: this.chantierEdit.geom_wkt,
          };
          const that = this;
          log.w(`# in saveDialog for existing chantier id:${currentID} data:`, tempChantier);
          chantier.saveChantier(currentID, tempChantier, (retval, errorMsg) => {
            if (errorMsg === 'SUCCESS') {
              log.w(`# in saveDialog callback for chantier.saveChantier id:${currentID} call val`, retval);
              // retval is the number of row affected
              that.showMessage(`Les données de ce chantier id:${currentID} ont été sauvée dans la BD ! `, 'success');
              that.registerWithChantier(currentID, true, true);
              // mise a jour de la carte
              that.getChantierList();
              that.getChantierListParticipants();
              // this.$refs.mymap.loadGeojsonData(this.chantiersGeojsonData);
              // this.$refs.mymap.updateScreen();
              if (that.closeHandlerActive) {
                window.removeEventListener('beforeunload', myOnCloseHandlerwindow, false);
                that.closeHandlerActive = false;
              }
              that.closeDialog();
            } else {
              log.e(`# ERROR in saveDialog callback for chantier.saveChantier id:${this.chantierEdit.id} call
            ERROR : ${errorMsg}
            val`, retval);
              that.showMessage(`ERREUR pendant la sauvegarde du chantier id:${currentID} dans la BD !
              ${errorMsg}`, 'error');
            }
          });
        } else {
          // SAVING NEW OBJECT
          // TODO ADD stockage champs participation
          log.l(`# in saveDialog, will save new chantier ${this.chantierEditedIndex}`);
          // toujours vrai pour une edition ou creation
          this.chantierEdit.is_external = true;
          this.chantierEdit.identiteleader = getUserId();
          this.chantierEdit.entiteleader = getUserName();
          this.chantierEdit.datecreated = new Date();
          const that = this;
          const tempChantier = {
            name: this.chantierEdit.title,
            idcreator: getUserId(),
            identiteleader: getUserId(),
            entiteleader: getUserName(),
            description: this.chantierEdit.description,
            commentaire: this.chantierEdit.commentaire,
            planified_datestart: this.chantierEdit.planified_date_begin,
            planified_dateend: this.chantierEdit.planified_date_end,
            real_datestart: this.chantierEdit.real_date_begin,
            real_dateend: this.chantierEdit.real_date_end,
            is_projet_definitif_en_cours: this.chantierEdit.is_projet_definitif_en_cours,
            infos_complementaire_partenaire: this.chantierEdit.infos_complementaire_partenaire,
            geom_polygon: this.chantierEdit.geom_wkt,
          };
          chantier.newChantier(tempChantier, (retval, errorMsg) => {
            if (errorMsg === 'SUCCESS') {
              log.w('# in saveDialog callback for chantier.newChantier call val', retval);
              // retval is the new index
              that.showMessage(`Les données de ce chantier ont été sauvée dans la Base id ${retval}`, 'success');
              that.chantierEdit.id = retval;
              that.registerWithChantier(that.chantierEdit.id, true, true);
              const tempNew = {
                type: 'Feature',
                geometry: that.chantierEdit.geom_GeoJSON,
                properties: that.chantierEdit,
              };
              log.w('# in saveDialog for new item', tempNew);
              // sauvegarde en memoire locale navigateur
              that.chantiersGeojsonData.features.push(tempNew);
              // mise a jour de la carte
              that.getChantierList();
              that.getChantierListParticipants();
              // this.$refs.mymap.loadGeojsonData(that.chantiersGeojsonData);
              // this.$refs.mymap.updateScreen();
              if (that.closeHandlerActive) {
                window.removeEventListener('beforeunload', myOnCloseHandlerwindow, false);
                that.closeHandlerActive = false;
              }
              that.closeDialog();
            } else {
              log.e(`# ERROR in saveDialog callback for chantier.newChantier call
            ERROR : ${errorMsg}
            val`, retval);
              this.showMessage(`ERREUR pendant la sauvegarde du chantier !
              ${errorMsg}`, 'error');
            }
          });
        }
      } else {
        log.e('# ERRORS in saveDialog');
      }
    },

    getChantierItembyId(id) {
      for (let i = 0; i < this.chantiersGeojsonData.features.length; i += 1) {
        const currentItem = this.chantiersGeojsonData.features[i];
        if (currentItem.properties.id === id) return currentItem;
      }
      return null;
    },

    handleMapCLick(info) {
      log.t('#### In handleMapCLick cgil-vue-olmap event mapclick received : ', info);
      if (this.panelsDisabled) {
        log.w('#### In handleMapCLick EN COURS D EDITION DONC ON FAIT RIEN');
      } else if ((!isNullOrUndefined(info.features)) && (info.features.length > 0)) {
        log.w('OBJET TROUVE :', info.features[0]);
        // this.chantierEditedIndex = this.chantiersGeojsonData.features.indexOf(item);
        const realItem = this.getChantierItembyId(info.features[0].data.id);
        if (this.canUserEditItem(realItem)) {
          this.editItem(realItem);
        } else {
          this.showItem(realItem);
        }
      } else {
        log.w('RIEN TROUVE');
      }
    },

    listChantierRequest() {
      log.t('#in listChantierRequest');
      this.dialogFormChantier = false;
      // this.dialogFormChantierReadOnlyMode = false;
      this.editToolbarEnabled = false;
      this.showRegisterForm = false;
      this.$refs.mymap.clearNewFeatures();
      this.togleList();
    },
  }, // end of methods
};
</script>
